import { Directive, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ColumnDefinition, CustomCellComponent } from '@vendasta/va-filter2-table';
import { AccountsCustomFieldsData } from '../auxiliary-data-accounts-table.data-model';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[manageAccountsTableColumn]',
  standalone: false,
})
export class AuxDataAccountsTableColumnDirective implements CustomCellComponent<AccountsCustomFieldsData> {
  @Input() columnDefinition: ColumnDefinition;
  @Input() translateService: TranslateService;
  @Input() element: AccountsCustomFieldsData;
}
